import {
  IKeyValuePair,
  ISelectGroupedItemsProps,
} from "../interfaces-and-types";

export const industries: IKeyValuePair[] = [
  {
    key: "Accounting",
    value: "Accounting",
  },
  {
    key: "Airlines/Aviation",
    value: "Airlines/Aviation",
  },
  {
    key: "Alternative Dispute Resolution",
    value: "Alternative Dispute Resolution",
  },
  {
    key: "Alternative Medicine",
    value: "Alternative Medicine",
  },
  {
    key: "Animation",
    value: "Animation",
  },
  {
    key: "Apparel & Fashion",
    value: "Apparel & Fashion",
  },
  {
    key: "Architecture & Planning",
    value: "Architecture & Planning",
  },
  {
    key: "Arts and Crafts",
    value: "Arts and Crafts",
  },
  {
    key: "Automotive",
    value: "Automotive",
  },
  {
    key: "Aviation & Aerospace",
    value: "Aviation & Aerospace",
  },
  {
    key: "Banking",
    value: "Banking",
  },
  {
    key: "Biotechnology",
    value: "Biotechnology",
  },
  {
    key: "Broadcast Media",
    value: "Broadcast Media",
  },
  {
    key: "Building Materials",
    value: "Building Materials",
  },
  {
    key: "Business Supplies and Equipment",
    value: "Business Supplies and Equipment",
  },
  {
    key: "Capital Markets",
    value: "Capital Markets",
  },
  {
    key: "Chemicals",
    value: "Chemicals",
  },
  {
    key: "Civic & Social Organization",
    value: "Civic & Social Organization",
  },
  {
    key: "Civil Engineering",
    value: "Civil Engineering",
  },
  {
    key: "Commercial Real Estate",
    value: "Commercial Real Estate",
  },
  {
    key: "Computer & Network Security",
    value: "Computer & Network Security",
  },
  {
    key: "Computer Games",
    value: "Computer Games",
  },
  {
    key: "Computer Hardware",
    value: "Computer Hardware",
  },
  {
    key: "Education",
    value: "Education",
  },
  {
    key: "Others",
    value: "others",
  },
];

export const countries: ISelectGroupedItemsProps[] = [
  {
    groupLabel: "Africa",
    options: [
      { text: "Algeria", value: "DZ" },
      { text: "Angola", value: "AO" },
      { text: "Benin", value: "BJ" },
      { text: "Botswana", value: "BW" },
      { text: "Burkina Faso", value: "BF" },
      { text: "Burundi", value: "BI" },
      { text: "Cameroon", value: "CM" },
      { text: "Central African Republic", value: "CF" },
      { text: "Chad", value: "TD" },
      { text: "Comoros", value: "KM" },
      {
        text: "Democratic Republic of the Congo",
        value: "CD",
      },
      { text: "Djibouti", value: "DJ" },
      { text: "Egypt", value: "EG" },
      { text: "Equatorial Guinea", value: "GQ" },
      { text: "Eritrea", value: "ER" },
      { text: "Ethiopia", value: "ET" },
      { text: "Gabon", value: "GA" },
      { text: "Gambia", value: "GM" },
      { text: "Ghana", value: "GH" },
      { text: "Guinea", value: "GN" },
      { text: "Guinea-Bissau", value: "GW" },
      { text: "Kenya", value: "KE" },
      { text: "Lesotho", value: "LS" },
      { text: "Liberia", value: "LR" },
      { text: "Libya", value: "LY" },
      { text: "Madagascar", value: "MG" },
      { text: "Malawi", value: "MW" },
      { text: "Mali", value: "ML" },
      { text: "Mauritania", value: "MR" },
      { text: "Mauritius", value: "MU" },
      { text: "Morocco", value: "MA" },
      { text: "Mozambique", value: "MZ" },
      { text: "Namibia", value: "NA" },
      { text: "Niger", value: "NE" },
      { text: "Nigeria", value: "NG" },
      { text: "Rwanda", value: "RW" },
      { text: "Sao Tome and Principe", value: "ST" },
      { text: "Senegal", value: "SN" },
      { text: "Seychelles", value: "SC" },
      { text: "Sierra Leone", value: "SL" },
      { text: "Somalia", value: "SO" },
      { text: "South Africa", value: "ZA" },
      { text: "South Sudan", value: "SS" },
      { text: "Sudan", value: "SD" },
      { text: "Swaziland", value: "SZ" },
      { text: "Tanzania", value: "TZ" },
      { text: "Togo", value: "TG" },
      { text: "Tunisia", value: "TN" },
      { text: "Uganda", value: "UG" },
      { text: "Zambia", value: "ZM" },
      { text: "Zimbabwe", value: "ZW" },
    ],
  },
  {
    groupLabel: "Asia",
    options: [
      { text: "Afghanistan", value: "AF" },
      { text: "Armenia", value: "AM" },
      { text: "Azerbaijan", value: "AZ" },
      { text: "Bahrain", value: "BH" },
      { text: "Bangladesh", value: "BD" },
      { text: "Bhutan", value: "BT" },
      { text: "Brunei", value: "BN" },
      { text: "Cambodia", value: "KH" },
      { text: "China", value: "CN" },
      { text: "Cyprus", value: "CY" },
      { text: "Georgia", value: "GE" },
      { text: "Hong Kong", value: "HK" },
      { text: "India", value: "IN" },
      { text: "Indonesia", value: "ID" },
      { text: "Iran", value: "IR" },
      { text: "Iraq", value: "IQ" },
    ],
  },
  {
    groupLabel: "Europe",
    options: [
      { text: "Albania", value: "AL" },
      { text: "Andorra", value: "AD" },
      { text: "Armenia", value: "AM" },
      { text: "Austria", value: "AT" },
      { text: "Azerbaijan", value: "AZ" },
      { text: "Belarus", value: "BY" },
      { text: "Belgium", value: "BE" },
      { text: "Bosnia and Herzegovina", value: "BA" },
      { text: "Bulgaria", value: "BG" },
      { text: "Croatia", value: "HR" },
      { text: "Cyprus", value: "CY" },
      { text: "Czech Republic", value: "CZ" },
      { text: "Denmark", value: "DK" },
      { text: "Estonia", value: "EE" },
      { text: "Finland", value: "FI" },
      { text: "France", value: "FR" },
      { text: "Georgia", value: "GE" },
      { text: "Germany", value: "DE" },
      { text: "Greece", value: "GR" },
      { text: "Hungary", value: "HU" },
      { text: "Iceland", value: "IS" },
      { text: "Ireland", value: "IE" },
      { text: "Italy", value: "IT" },
      { text: "Kazakhstan", value: "KZ" },
      { text: "Kosovo", value: "XK" },
      { text: "Latvia", value: "LV" },
      { text: "Liechtenstein", value: "LI" },
      { text: "Lithuania", value: "LT" },
      { text: "Luxembourg", value: "LU" },
      { text: "Macedonia", value: "MK" },
      { text: "Malta", value: "MT" },
      { text: "Moldova", value: "MD" },
      { text: "Monaco", value: "MC" },
      { text: "Montenegro", value: "ME" },
      { text: "Netherlands", value: "NL" },
      { text: "Norway", value: "NO" },
      { text: "Poland", value: "PL" },
      { text: "Portugal", value: "PT" },
      { text: "Romania", value: "RO" },
      { text: "Russia", value: "RU" },
      { text: "San Marino", value: "SM" },
      { text: "Serbia", value: "RS" },
      { text: "Slovakia", value: "SK" },
      { text: "Slovenia", value: "SI" },
      { text: "Spain", value: "ES" },
      { text: "Sweden", value: "SE" },
      { text: "Switzerland", value: "CH" },
      { text: "Turkey", value: "TR" },
      { text: "Ukraine", value: "UA" },
      { text: "United Kingdom", value: "GB" },
      { text: "Vatican City", value: "VA" },
    ],
  },
  {
    groupLabel: "North America",
    options: [
      { text: "Antigua and Barbuda", value: "AG" },
      { text: "Bahamas", value: "BS" },
      { text: "Barbados", value: "BB" },
      { text: "Belize", value: "BZ" },
      { text: "Canada", value: "CA" },
      { text: "Costa Rica", value: "CR" },
      { text: "Cuba", value: "CU" },
      { text: "Dominica", value: "DM" },
      { text: "Dominican Republic", value: "DO" },
      { text: "El Salvador", value: "SV" },
      { text: "Grenada", value: "GD" },
      { text: "Guatemala", value: "GT" },
      { text: "Haiti", value: "HT" },
      { text: "Honduras", value: "HN" },
      { text: "Jamaica", value: "JM" },
      { text: "Mexico", value: "MX" },
      { text: "Nicaragua", value: "NI" },
      { text: "Panama", value: "PA" },
      { text: "Saint Kitts and Nevis", value: "KN" },
      { text: "Saint Lucia", value: "LC" },
      {
        text: "Saint Vincent and the Grenadines",
        value: "VC",
      },
      { text: "Trinidad and Tobago", value: "TT" },
      { text: "United States", value: "US" },
    ],
  },
  {
    groupLabel: "Oceania",
    options: [
      { text: "Australia", value: "AU" },
      { text: "Fiji", value: "FJ" },
      { text: "Kiribati", value: "KI" },
      { text: "Marshall Islands", value: "MH" },
      { text: "Micronesia", value: "FM" },
      { text: "Nauru", value: "NR" },
      { text: "New Zealand", value: "NZ" },
      { text: "Palau", value: "PW" },
      { text: "Papua New Guinea", value: "PG" },
      { text: "Samoa", value: "WS" },
      { text: "Solomon Islands", value: "SB" },
      { text: "Tonga", value: "TO" },
      { text: "Tuvalu", value: "TV" },
      { text: "Vanuatu", value: "VU" },
    ],
  },
];

export const currencies = [
  { text: "NGN - Nigerian Naira", value: "NGN", currencySymbol: "₦" },
  { text: "USD - United States Dollar", value: "USD", currencySymbol: "$" },
  { text: "EUR - Euro", value: "EUR", currencySymbol: "€" },
  { text: "GBP - Pound Sterling", value: "GBP", currencySymbol: "£" },
  // { text: "AUD - Australian Dollar", value: "AUD", currencySymbol: "AU$" },
  // { text: "CAD - Canadian Dollar", value: "CAD", currencySymbol: "CA$" },
  // { text: "CHF - Swiss Franc", value: "CHF", currencySymbol: "CHF" },
];
